import { BehaviorSubject } from 'rxjs';
import { Subject } from '@shared-logic/subjects/constants/subject.interfaces';

export const brokersSellers$ = new BehaviorSubject<Subject[]>([]);

export function updateBrokersSellers(data: Subject[]) {
    brokersSellers$.next(data);
}
